<template>
  <transition name="fade">
    <button
      v-if="isVisible"
      class="scroll-to-top bg-darkest fixed hover:bg-darker"
      aria-label="Scroll to top"
      @click="scrollToTop"
    >
      <img
        src="/icons/arrow-right-inv.svg"
        class="w-16 h-16 -rotate-90"
        alt=""
      >
    </button>
  </transition>
</template>

<script setup lang="ts">
import { ref, onMounted, onUnmounted } from 'vue';

const isVisible = ref(false);

const toggleVisibility = () => {
  isVisible.value = window.scrollY > 300;
};

const scrollToTop = () => {
  window.scrollTo({ top: 0, behavior: 'smooth' });
};

onMounted(() => {
  window.addEventListener('scroll', toggleVisibility);
});

onUnmounted(() => {
  window.removeEventListener('scroll', toggleVisibility);
});
</script>

<style scoped lang="postcss">
.scroll-to-top {
  bottom: 5.5rem;
  right: 1rem;
  color: white;
  border: none;
  padding: 1rem 1rem;
  border-radius: 50%;
  cursor: pointer;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
  font-size: 1.2rem;
  z-index: 1000;
  transition: background-color 0.3s ease;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.4s;
}
.fade-enter-from, .fade-leave-to {
  opacity: 0;
}
</style>
